import { useConnection } from "@solana/wallet-adapter-react";
import { useEffect, useState } from "react";

import { useRefreshContext } from "../../contexts/refresh";
import { STAKED_TULIP_MINT, TULIP_STAKING_VAULT_ID } from "../../models/tulip";

type TulipStakingInfo = {
  apr: number;
  ratio: number;
};

export const useTulipStaking = () => {
  const { connection } = useConnection();
  const { refreshing } = useRefreshContext();

  const [stakeInfo, setStakeInfo] = useState<TulipStakingInfo>({ apr: 0, ratio: 0 });

  const fetchSTulipRatioAndAPR = async () => {
    const starting_ratio = 1.000349406;
    const starting_timestamp = 1648598400;

    const depositedTulipBalance =
      (await connection.getTokenAccountBalance(TULIP_STAKING_VAULT_ID, "confirmed")).value.uiAmount ?? 0;
    const sTulipSupply = (await connection.getTokenSupply(STAKED_TULIP_MINT, "confirmed")).value.uiAmount ?? 1;
    const ratio = depositedTulipBalance / sTulipSupply;
    const timeElapsed = new Date().getTime() / 1000 - starting_timestamp;
    const totalYield = ((depositedTulipBalance * starting_ratio) / sTulipSupply - 1.0) * 100;
    const yieldPerSecond = totalYield / timeElapsed;
    const apr = yieldPerSecond * 86400 * 365;
    return { apr, ratio };
  };

  useEffect(() => {
    fetchSTulipRatioAndAPR()
      .then(setStakeInfo)
      .catch(() => console.log("Error fetching Tulip Staking APR/Ratio data."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection, refreshing]);

  return stakeInfo;
};
